import { DocumentUpstreamState } from '../../types/closing-documents.types';
import { DocumentPreviewKind } from '../document-preview/document-preview.types';

//REV-21363 — types of the account's `Dokumente` area (Pure View).
//
//The SHARED vocabulary of the document flow lives in `lib/types/closing-documents.types.ts`
//(promoted there by REV-21368) — `MarkNotRelevantEvent` comes from there, it is not redeclared.
//What stays here is what only THIS area has: the shape of a document as its dropdown lists it.

/**
 * One document of THIS account, as the area lists it.
 *
 * Deliberately narrower than the hub's `DocumentRow` and the single page's `DocumentDetail`: this
 * area shows neither assignment nor confidence nor validity. It answers WHICH document, and shows
 * it. Widening it later is cheap; carrying fields nothing renders is not.
 */
export interface AccountDocument {
    id: string;
    filename: string;
    /**
     * ⚠️ INGEST is PDF-only (ADR-0009 §12), DISPLAY is not — an agent-generated `.xlsx` is listed
     * in the dropdown like any other document and shows the non-PDF placeholder.
     */
    previewKind: DocumentPreviewKind;
    /** `null` until the scan releases the file (scanStatus != CLEAN) — a placeholder, not an error. */
    previewUrl: string | null;
    /**
     * REV-21964 · C1–C4 — where the upstream file stands. Absent means `present`, which is also
     * every manual upload.
     *
     * ⚠️ Shown HERE and not only in the hub because this is the surface where it matters most: this
     * pane belongs to an ACCOUNT, so every document in it backs one. A trustee reconciling an
     * account has to see that the evidence is no longer where it came from, and asking them to go
     * back to the hub to find that out is asking them not to find out.
     *
     * The field was already travelling — the container feeds this pane the same `DocumentRow` the
     * hub gets — the pane simply declared a narrower type and dropped it.
     */
    upstreamState?: DocumentUpstreamState;
    /** `true` when the document backs an account (C2). In this pane that is always the case. */
    upstreamNoticeIsUrgent?: boolean;
}
